module.exports = __webpack_public_path__ + "components/rewards/christy/static/logo-f5d5926acedfca12fa49a85c57f65a8f.webp";